<template>
  <!--  <div id="nav">-->
  <!--    <router-link to="/">Home</router-link> |-->
  <!--    <router-link to="/about">About</router-link>-->
  <!--  </div>-->
  <router-view/>
  <div class="powered-text">
    Powered by Vimmi
  </div>
</template>
<script>
  export default {
    name: 'App',
    mounted() {

    }
  }
</script>

<style lang="scss">

  @import "~bootstrap";
  @import "~video.js/src/css/video-js.scss";
  @import "~vimmi-player/src/styles/vjs-base";

  html, body {
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
    background-color: #FFFFFF;
    font-family: Roboto;
    font-style: normal;
    overflow: hidden;
  }

  #app {
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
    color: #343434;
  }

  .aspect-ratio-box {
    height: 0;
    overflow: hidden;
    //padding-top: 9/16 * 100%;
    position: relative;

    &.ar-16-9 {
      padding-top: 9/16 * 100%;
    }

    &.ar-1 {
      padding-top: 100%;
    }

    &:not(.ar-16-9):not(.ar-1) {
      padding-top: 9/16 * 100%;
    }


    .aspect-ratio-box-inside {
      text-align: center;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  .powered-text {
    font-size: 10px;
    line-height: 16px;
    position: absolute;
    bottom: 0.5rem;
    right: 0.5rem;
    color: #343434;
    opacity: 0.2;
    @include media-breakpoint-down(md) {

      bottom: 0.2rem;
      right: 0.2rem;

    }
  }
</style>
